// extracted by mini-css-extract-plugin
export default {"MainContainer":"ConfirmationModal_MainContainer__BUWgC","Form":"ConfirmationModal_Form__LXGgC"};